const LatviaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111741)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 0C10.7594 0 2.98396 6.26727 0.688965 14.7826H39.3111C37.016 6.26727 29.2405 0 20 0Z"
        fill="#A2001D"
      />
      <path
        d="M20 39.9994C29.2405 39.9994 37.016 33.7321 39.311 25.2168H0.688965C2.98396 33.732 10.7594 39.9994 20 39.9994Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111741">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LatviaSvg;
